export default __webpack_public_path__ + "static/media/bg1Civ.d6846eea.png";